export default __webpack_public_path__ + "static/media/about-greeting-4.a6b04202.png";